import { render } from "./YoutubeUrlLayoutEditor.vue?vue&type=template&id=34aea19a&scoped=true&ts=true"
import script from "./YoutubeUrlLayoutEditor.vue?vue&type=script&lang=ts"
export * from "./YoutubeUrlLayoutEditor.vue?vue&type=script&lang=ts"

import "./YoutubeUrlLayoutEditor.vue?vue&type=style&index=0&id=34aea19a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34aea19a"]])

export default __exports__